import { gsap } from 'gsap'
import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.audio = this.el.querySelector('.o-testimonial_audio > audio')
    this.audioPlaying = false

    this.bars = this.el.querySelectorAll('.o-testimonial_bars > span')
    this.rafEqualizer = null
    this.timeoutEqualizer = null

    this.playEqualizer = this.playEqualizer.bind(this)

    setTimeout(() => {
      const items = this.el.querySelector('.o-testimonial_content').querySelectorAll('.word')

      this.tl = gsap.timeline({ paused: true })
      this.tl.to(items, {
        opacity: 1,
        duration: 0.8,
        ease: 'none',
        stagger: 0.1
      })
    }, 500)

    this.onTestimonialProgress = this.onTestimonialProgress.bind(this)

    window.addEventListener('testimonialProgress', this.onTestimonialProgress)

    this.events = { click: { toggleAudio: 'toggleAudio' } }
  }

  onTestimonialProgress(e) {
    if (this.tl) {
      this.tl.progress(e.detail.progress)
    }
  }

  playEqualizer() {
    this.timeoutEqualizer = setTimeout(() => {
      this.rafEqualizer = window.requestAnimationFrame(this.playEqualizer)

      this.bars.forEach((bar) => {
        bar.style.transform = `scaleY(${Math.random()})`
      })
    }, 150)
  }

  pauseEqualizer() {
    clearTimeout(this.timeoutEqualizer)
    window.cancelAnimationFrame(this.rafEqualizer)

    this.bars.forEach((bar) => {
      bar.style.transform = 'scaleY(0.1)'
    })
  }

  toggleAudio() {
    if (this.audioPlaying === true) {
      this.audio.pause()
      this.audioPlaying = false
      this.pauseEqualizer()
    }
    else {
      this.audio.play()
      this.audioPlaying = true
      this.playEqualizer()
    }
  }

  pauseAudio(e) {
    if (e.way === 'leave') {
      if (this.audioPlaying === true) {
        this.audio.pause()
        this.audioPlaying = false
        this.pauseEqualizer()
      }
    }
  }

  destroy() {
    window.removeEventListener('testimonialProgress', this.onTestimonialProgress)
    clearTimeout(this.timeoutEqualizer)
    window.cancelAnimationFrame(this.rafEqualizer)
  }
}
